// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__346IF","footer":"styles_footer__3Rihp"};